const data = {
  snackbarMail: false,
  status: true,
  response: null,
  spinner: false,
};

const getters = {
  GET_SNACKBAR_MAIL() {
    return data.snackbarMail;
  },
  FAIL() {
    return data.error;
  },
  GET_SHEET_RESPONSE() {
    return data.response;
  },
  GET_SPINNER() {
    return data.spinner;
  },
};

const mutations = {
  TOGGLE_SNACKBAR_MAIL(state) {
    state.snackbarMail = !state.snackbarMail;
  },
  SET_RESPONSE(state, payload) {
    state.response = payload;
  },
};

const actions = {
  async CONTACT_MAIL({ commit, state }, message) {
    state.spinner = true;
    try {
      const response = await fetch(
        'http://localhost:3000/api/v1/mail/',
        // 'https://rizeshouse-api.herokuapp.com/api/v1/mail/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(message),
        },
      );

      const res = await response.json();
      state.response = res;
      state.fail = !res.success;

      commit('TOGGLE_SNACKBAR_MAIL');
      state.spinner = false;
    } catch (error) {
      commit('TOGGLE_SNACKBAR_MAIL');
      state.fail = true;
      state.response = error;
      state.spinner = false;
    }
  },
  async CONTACT_SHEET({ commit, state }, message) {
    state.spinner = true;
    try {
      const response = await fetch(
        // 'http://localhost:3000/api/v1/sheet/',
        'https://clumsy-rose-sundress.cyclic.app/api/v1/sheet',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(message),
        },
      );
      const res = await response.json();
      state.spinner = false;
      commit('SET_RESPONSE', res);
    } catch (error) {
      commit('TOGGLE_SNACKBAR_MAIL');
      state.status = false;
      state.response = error;
      state.spinner = false;
    }
  },
};

export default {
  state: data,
  getters,
  actions,
  mutations,
};
